import { Button } from "@/components/ui/button"
import { ArrowRight } from "lucide-react"
import { Link } from "react-router-dom"
import { DashboardMockup } from "./mockups/dashboard-mockup"
import { Analytics } from "@/lib/analytics"

export function HeroSection() {
	return (
		<section className="relative py-16 sm:py-24 lg:py-32 px-4">
			<div className="max-w-6xl mx-auto">
				<div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-16">
					{/* Text */}
					<div className="flex-1 text-center lg:text-left">
						<h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-extrabold tracking-tight text-sky-950 dark:text-sky-50 drop-shadow-sm leading-[1.1] transition-colors duration-300">
							Track Every Dividend.{" "}
							<span className="block mt-2 relative">
								<span className="absolute inset-0 text-sky-600/20 dark:text-sky-100/20 blur-2xl animate-pulse-slow">
									Plan Your Freedom.
								</span>
								<span className="relative text-transparent bg-clip-text bg-gradient-to-r from-sky-700 via-sky-400 to-sky-700 dark:from-sky-200 dark:via-sky-100 dark:to-sky-200 bg-[length:200%_auto] animate-shine">
									Plan Your Freedom.
								</span>
							</span>
						</h1>

						<p className="mt-6 text-base sm:text-lg md:text-xl text-sky-900/75 dark:text-sky-100/65 max-w-xl mx-auto lg:mx-0 leading-relaxed transition-colors duration-300">
							Track dividends across unlimited portfolios and holdings. 60+ exchanges, all major
							currencies.
						</p>

						<div className="mt-10 flex flex-col sm:flex-row gap-4 items-center justify-center lg:justify-start">
							<Link
								to="/signup"
								onClick={() =>
									Analytics.capture("CTA Clicked", { cta: "Create Free Account", location: "hero" })
								}
							>
								<Button
									size="lg"
									className="font-bold text-base h-12 px-8 rounded-full bg-sky-600 hover:bg-sky-700 text-white dark:bg-sky-500 dark:hover:bg-sky-400 dark:text-sky-950 shadow-[0_10px_40px_-10px_rgba(14,165,233,0.6)] dark:shadow-[0_10px_40px_-10px_rgba(14,165,233,0.3)] transition-all hover:scale-105"
								>
									Create Free Account <ArrowRight className="ml-2 h-5 w-5" />
								</Button>
							</Link>
							<Link
								to="/demo"
								onClick={() =>
									Analytics.capture("CTA Clicked", { cta: "Try the Demo", location: "hero" })
								}
							>
								<Button
									variant="ghost"
									size="lg"
									className="rounded-full text-base font-medium text-sky-900 hover:bg-sky-900/5 hover:text-sky-950 dark:text-sky-100 dark:hover:bg-sky-100/10 dark:hover:text-sky-50 transition-colors"
								>
									Try the Demo
								</Button>
							</Link>
						</div>

						<p className="mt-4 text-sm text-sky-600/60 dark:text-sky-400/50">
							No holding limits · No setup fees
						</p>
					</div>

					{/* Mockup */}
					<div className="flex-1 w-full max-w-sm sm:max-w-md lg:max-w-none">
						<DashboardMockup />
					</div>
				</div>
			</div>
		</section>
	)
}
